import UserAvatar from '../UserAvatar'
import * as Styled from './styled'
import { cutEmail } from './utils'
import type { IProps } from './types'
import { useSelector } from 'react-redux'
import { TRootState } from 'store/types'

const UserInfoBlock = ({ isExpanded, onClick }: IProps) => {
  const {
    firstName,
    lastName,
    email = ''
  } = useSelector((state: TRootState) => state.user.data)
  const { isLoading } = useSelector((state: TRootState) => state.user)
  const userFullName = `${firstName}${lastName ? ` ${lastName}` : ''}`

  if (isLoading) return null

  return (
    <Styled.UserInfoBlock $isExpanded={isExpanded} onClick={onClick}>
      <UserAvatar />
      <Styled.UserDetails>
        <Styled.Name>{userFullName}</Styled.Name>
        <Styled.Email>{cutEmail(email, 21)}</Styled.Email>
      </Styled.UserDetails>
    </Styled.UserInfoBlock>
  )
}

export default UserInfoBlock
